var map = {
	"./localized-urls/en.json": 7890,
	"./localized-urls/es-PER.json": 11303,
	"./localized-urls/es.json": 73681,
	"./localized-urls/pt.json": 27305,
	"./translations/PEN.json": 79174,
	"./translations/en.json": 39048,
	"./translations/es.json": 36303,
	"./translations/pt.json": 48555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83893;